<div
  class="rowcard w-100 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
  <div>
    <sb-bool-operator [disabled]="disabled" *ngFor="let operator of leftOperators; let i = index" [operator]="operator"
                      (optionSelected)="changeLeftOperator($event, i)"></sb-bool-operator>
    <sb-dropdown-box *ngIf="!disabled" [disabled]="disabled || getOptions().length === 0" [options]="getOptions()"
                     (optionSelected)="onLeftOperatorSelected($event)"></sb-dropdown-box>
  </div>
  <div class="label-lg">
    {{atomTypeText}}
  </div>
  <div class="mb-2" *ngFor="let reference of references | keyvalue: valueAscOrder">
    <div class="btn-group w-100 mt-2">
      <div class="btn btn-outline-secondary disabled" style="cursor: default;">
        {{referenceText.get(reference.key)}}
      </div>
      <ng-container *ngIf="!disabled; else groupDisabled">
        <div (click)="showNewReferenceModal(reference, atom)" class="btn btn-outline-secondary cursor-pointer">
          <b>{{fieldText.get(reference.key) ? fieldText.get(reference.key) : '. . .'}}</b>
        </div>
      </ng-container>
      <ng-template #groupDisabled>
        <div class="btn btn-outline-secondary disabled" [attr.disabled]="disabled" style="cursor: default;">
          <b>{{fieldText.get(reference.key) ? fieldText.get(reference.key) : '. . .'}}</b>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <sb-bool-operator [disabled]="disabled" *ngFor="let operator of rightOperators; let i = index" [operator]="operator"
                      (optionSelected)="deleteRightOperator(i)"></sb-bool-operator>
    <sb-dropdown-box *ngIf="!disabled" [disabled]="disabled" [options]="[')']"
                     (optionSelected)="onRightOperatorSelected($event)"></sb-dropdown-box>
    <button *ngIf="!disabled" class="btn btn-danger" (click)="onDeleteClick()">
      <sb-icon icon="trash"></sb-icon>
    </button>
  </div>
</div>
